import Vue from 'vue'
// Change this path if required
import UniversalLoginComponent from "../../../vendor/pm-connect/universal-login-laravel/src/resources/assets/js/components/UniversalLoginComponent.vue";

new Vue({
    el: '#universal-login',
    components: {UniversalLoginComponent}
});
